import React, {useState, useEffect, useCallback, useContext} from "react";
import {Form, Input, Select} from "antd";
import TableFilterControlsSection from "@common/TableFilterControlsSection";
import {debounce} from "lodash";
import {BrandContext} from "@context/BrandContext";

const DiagnosticTestFilters = props => {
    const {
        popupMatchSelectWidth= true,
        onUpdate,
        onLoadComplete
    } = props;

    const brandConfig = useContext(BrandContext),
        [difficultyLevelOptions, setDifficultyLevelOptions] = useState([]);


    const debouncedInputChange = useCallback(
        debounce((e) => {
            handleChange();
        }, 500), []);

    useEffect(()=>{
        let testDifficultyLevels = [];
        const questionLevelCount = brandConfig.testQuestionLevels;
        if(questionLevelCount && questionLevelCount > 0){
            const levelNames = brandConfig.testQuestionLevelNames;
            for(let i = 0; i < questionLevelCount; i++){
                testDifficultyLevels.push({key:(i+1), value:levelNames[i]});
            }
        }
        setDifficultyLevelOptions(testDifficultyLevels);
        onLoadComplete?.();
    },[]);

    const handleChange = ()=>{
        onUpdate?.();
    }

    return (
        <TableFilterControlsSection key="diagnostic-test-filters" showDivider={false}>
            <Form.Item label="Difficulty"
                       name="testDifficultyLevel"
                       className={'padding-b--s'}
            >
                <Select className={'margin-t--s'} onChange={handleChange} popupMatchSelectWidth={popupMatchSelectWidth}>
                    <Select.Option key={'All'}>All</Select.Option>
                    {difficultyLevelOptions.map((option)=>{
                        return <Select.Option key={option.key}>{option.value}</Select.Option>;
                    })}
                </Select>
            </Form.Item>
            <Form.Item label="Skill keyword"
                       name="skillKeyWord"
                       className={'padding-b--s'}
            >
                <Input className={'margin-t--s'} allowClear onChange={debouncedInputChange}/>
            </Form.Item>
        </TableFilterControlsSection>
    )
}

export default DiagnosticTestFilters;